export default {
  getBundleList: {
    title: '商品套餐-智慧推荐专区套餐分页列表',
    url: '/api/shop/area/getActivityAreaPackageList'
  },
  getBundleGoods: {
    title: '商品套餐-慧推荐专区套餐明细',
    url: '/api/shop/area/getActivityAreaPackageDetail'
  }
}
